export default "__VITE_ASSET__DwNUOxZD__"